/**
 * Constants for CSV Bulk Import feature
 *
 * @module ImportExportTab/constants
 */

// Maximum file size for CSV uploads (5MB)
export const MAX_FILE_SIZE = 5 * 1024 * 1024;

// Supported file extensions
export const ACCEPTED_FILE_TYPES = {
  'text/csv': ['.csv']
};

// Batch size for bulk import operations
export const IMPORT_BATCH_SIZE = 50;

// Available timezones for locations
export const TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu'
];

// Ownership types for locations
export const OWNERSHIP_TYPES = [
  'Company',
  'Franchise',
  'Licensed',
  'Joint Venture'
];

// Validation error types
export const VALIDATION_ERROR_TYPES = {
  REQUIRED_FIELD: 'REQUIRED_FIELD',
  INVALID_FORMAT: 'INVALID_FORMAT',
  DUPLICATE: 'DUPLICATE',
  INVALID_REFERENCE: 'INVALID_REFERENCE',
  INVALID_RELATIONSHIP: 'INVALID_RELATIONSHIP'
};

// Import status
export const IMPORT_STATUS = {
  IDLE: 'IDLE',
  UPLOADING: 'UPLOADING',
  PARSING: 'PARSING',
  VALIDATING: 'VALIDATING',
  READY: 'READY',
  IMPORTING: 'IMPORTING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};
